import { render, staticRenderFns } from "./UserBaseAdGroups.vue?vue&type=template&id=9009813a"
import script from "./UserBaseAdGroups.js?vue&type=script&lang=js&external"
export * from "./UserBaseAdGroups.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports